import * as PIXI from 'pixi.js';
  import { populate } from 'populate';


const raw = /* 4@4!8|raw|8!4@ */ {
  list: [
    {
      id: '74c33db3-b0cf-4cdd-a644-9717e94c3427',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '26025901-8fdc-4880-9882-7434c123059e',
      type: 'Container',
      name: 'trajectoryContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '74c33db3-b0cf-4cdd-a644-9717e94c3427'
    },
    {
      id: '0d3a9276-0187-483f-ade9-1476fd9fadff',
      type: 'Sprite',
      name: 'centerDot',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '0_bubble_grey',
      parent: '74c33db3-b0cf-4cdd-a644-9717e94c3427'
    },
    {
      id: '6105c5b1-07a0-408b-9a61-301291c75945',
      type: 'Container',
      name: 'currentBubbleContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '74c33db3-b0cf-4cdd-a644-9717e94c3427'
    },
    {
      id: '41094d87-02c2-4627-b442-0a2ba1644831',
      type: 'Container',
      name: 'nextBubbleContainer',
      className: '',
      x: -49,
      y: 32,
      scale: {
        x: 0.7,
        y: 0.7
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '74c33db3-b0cf-4cdd-a644-9717e94c3427'
    },
    {
      id: '0c780380-7719-46b0-aadc-7aad9f80c11d',
      type: 'Container',
      name: 'scoreContainer',
      className: '',
      x: 200,
      y: 15,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '74c33db3-b0cf-4cdd-a644-9717e94c3427'
    },
    {
      id: '4b6afdd7-9a08-43c6-8813-fad446b5b3c8',
      type: 'Container',
      name: 'chainContainer',
      className: '',
      x: -200,
      y: 15,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '74c33db3-b0cf-4cdd-a644-9717e94c3427'
    },
    {
      id: '6b71f3cc-d513-469f-8038-eb0927f55c05',
      type: 'Sprite',
      name: 'scoreBg',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0.5,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Score_Background',
      parent: '0c780380-7719-46b0-aadc-7aad9f80c11d'
    },
    {
      id: 'e1ae74b2-e1ba-4769-becb-bbbc7997ef7a',
      type: 'Text',
      name: 'scoreAmount',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '0',
      localize: false,
      maxWidth: 146,
      maxHeight: 51,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Futura-Bold',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '0c780380-7719-46b0-aadc-7aad9f80c11d'
    },
    {
      id: '69511a69-e8ea-4cb2-b04a-9958bfbcfff8',
      type: 'Text',
      name: 'scoreLabel',
      className: '',
      x: 0,
      y: -30,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Score:',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 20,
        fontWeight: 'normal',
        fontFamily: 'Futura-Bold',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '0c780380-7719-46b0-aadc-7aad9f80c11d'
    },
    {
      id: 'e4fb921a-d8cc-4601-8066-b29a3d8d47eb',
      type: 'Sprite',
      name: 'chainBg',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0.5,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Score_Background',
      parent: '4b6afdd7-9a08-43c6-8813-fad446b5b3c8'
    },
    {
      id: '5578507a-678f-43e6-8409-8735327a27e5',
      type: 'Text',
      name: 'chainAmount',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x0',
      localize: false,
      maxWidth: 146,
      maxHeight: 51,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Futura-Bold',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '4b6afdd7-9a08-43c6-8813-fad446b5b3c8'
    },
    {
      id: 'eed1fa72-90a9-4a37-8a60-97ddb9e2dfd5',
      type: 'Text',
      name: 'chainLabel',
      className: '',
      x: 0,
      y: -30,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Combo:',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 20,
        fontWeight: 'normal',
        fontFamily: 'Futura-Bold',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '4b6afdd7-9a08-43c6-8813-fad446b5b3c8'
    }
  ],
  x: 0,
  y: 0,
  width: 640,
  height: 960,
  handleResize: false
}; /* 4@4!8|raw|8!4@ */

type Filter = Partial<{
  root: boolean;
  trajectoryContainer: boolean;
  centerDot: boolean;
  currentBubbleContainer: boolean;
  nextBubbleContainer: boolean;
  scoreContainer: boolean;
  chainContainer: boolean;
  scoreBg: boolean;
  scoreAmount: boolean;
  scoreLabel: boolean;
  chainBg: boolean;
  chainAmount: boolean;
  chainLabel: boolean;

}>;

class Layout {
  public readonly root: PIXI.Container;
  public readonly trajectoryContainer: PIXI.Container;
  public readonly centerDot: PIXI.Sprite;
  public readonly currentBubbleContainer: PIXI.Container;
  public readonly nextBubbleContainer: PIXI.Container;
  public readonly scoreContainer: PIXI.Container;
  public readonly chainContainer: PIXI.Container;
  public readonly scoreBg: PIXI.Sprite;
  public readonly scoreAmount: PIXI.Text;
  public readonly scoreLabel: PIXI.Text;
  public readonly chainBg: PIXI.Sprite;
  public readonly chainAmount: PIXI.Text;
  public readonly chainLabel: PIXI.Text;


  constructor(filter?: Filter) {
    populate(this, raw, filter);
  }
}

export { Layout, Filter, raw };
